import React from "react";
import "./Notfound.css";
const NotFound = () => {
  return (
    <div
      className="w-full flex flex-wrap flex-row justify-content-center align-items-center"
      style={{
        height: "calc(100vh - 15rem)",
        color: "red",
        opacity: "0.8",
        fontSize: "1.6rem",
        fontWeight: 600,
      }}
    >
      404 - Page Not Found
    </div>
  );
};

export default NotFound;
